<template>
  <div>
    <el-dialog :visible.sync="visible" body-height="200" title="岗位批量导入">
      <el-upload
          class="upload-demo"
          ref="uploadFile"
          :action="actionUrl"
          :limit="1"
          :file-list="fileList"
          :on-change="change"
          :on-success="success"
          :on-remove="remove"
          :on-error="error"
          accept=".xlsx"
          :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
        <a style="color: #0d89e5;margin-left: 20px;" href='static/doc/岗位导入模板.xlsx' download="岗位导入模板.xlsx">导入模板下载</a>
<!--        <div slot="tip" class="el-upload__tip" style="color: red"><br>上传规则如下：-->
<!--          <br>1、上传岗位导入文件请使用下载模板，只能上传excel文件(限一个)-->
<!--          <br>2、模板中学科类型数据为：物理与数学,力学与工程,材料与化学,电子与信息,光学与电气工程,其他。（与系统一致,其余不识别）每个类型根据逗号分隔-->
<!--          <br>3、模板中科研方向请使用逗号分隔-->
<!--          <br>4、注红字段为必填项-->
<!--        </div>-->
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import settingHelp from "@/config/localSetting";
const config = settingHelp.getConfig();
const { remoteURL } = config;
import axios  from "axios";
import store from "@/store";
const h = axios.create({
  baseURL: remoteURL,
})
h.interceptors.request.use((config) => {
  const token = store.getters["user/accessToken"];
  if (token) {
    config.headers["Authorization"] = `${token}`;
  }
  return config
})
export default {
  name: "postInfoExcelImport",
  components:{},
  data() {
    return {
      fileList:[],
      visible:false,
      curRow: {},
      actionUrl:"",
    }
  },
  computed: {
    ...mapGetters('common', ['property']),
  },

  methods: {
    change(file){
      this.fileList=[]
      this.fileList.push(file)
    },
    remove(){
      this.fileList=[]
    },
    async submitUpload() {
      if (this.fileList.length === 0) {
        this.$message.error("请选择需要上传的文件！")
        return;
      }
      const formData = new FormData();
      formData.append("file", this.fileList[0].raw);
      let result = await h.request({
        url: "/postInfo/postInfoExcelImport",
        method: "POST",
        data: formData,
      })
      if(result.data&&result.data.code == 1100){
        this.$message.error("文件上传失败！"+ result.data.message);
      }else {
        this.$message.success("上传成功！")
        this.visible = false;
      }
    },
    success(data){
      this.$refs.edidForm.open(data.data)
    },
    error(data){
      this.$message.error("文件上传失败！");
    },
    open(){
      this.fileList=[]
      this.actionUrl=remoteURL+'/resume/postInfoExcelImport'
      this.visible = true
    }
  },
  //加载列属性必须为异步操作
  async mounted() {
  }
}
</script>
